import { useEffect, useRef } from "react";

export function useHandleGoBack(props) {
  const lastId = useRef();

  const listener = function () {
    const globalParams = new URLSearchParams(props.location.search);
    const destination = globalParams.get("destination")
      ? +globalParams.get("destination")
      : null;

    if (destination === lastId.current) {
      props.history.goBack();
      return;
    }

    let feature = null;

    if (destination) {
      lastId.current = destination;
      feature = { id: destination };
    }

    props.setCurrentFeature(feature);
  };

  useEffect(() => {
    window.addEventListener("popstate", listener, false);

    return () => {
      window.removeEventListener("popstate", listener, false);
    };
  }, []);
}
